import React, { useState } from "react";
import { Link } from "react-router-dom";
import { X, Tag, ArrowRight, Clock } from "lucide-react";
import { useApp } from "../../hooks/useApp";
import { formatDiscountValue, formatDate } from "../../utils/formatters";

const Marquee = () => {
  const { recentDiscounts, loading } = useApp();
  const [visible, setVisible] = useState(true);

  if (!visible || loading || !recentDiscounts || recentDiscounts.length === 0) {
    return null;
  }

  return (
    <div className="relative bg-gradient-to-r from-primary-600 via-primary-700 to-primary-800 text-white py-3 shadow-md overflow-hidden">
      <div className="container mx-auto px-4">
        {/* Верхня панель */}
        <div className="flex items-center justify-between mb-1">
          <div className="flex items-center space-x-2">
            <Tag size={18} className="text-primary-200" />
            <span className="text-sm font-semibold tracking-wide">
              Нові знижки
            </span>
          </div>

          <button
            onClick={() => setVisible(false)}
            className="text-primary-200 hover:text-white transition-colors p-1 rounded-full hover:bg-primary-500/30"
            aria-label="Закрити оголошення"
          >
            <X size={18} />
          </button>
        </div>

        {/* Бігучий рядок */}
        <div className="overflow-hidden">
          <div className="animate-marquee whitespace-nowrap flex items-center space-x-8">
            {recentDiscounts.map((discount) => (
              <Link
                key={discount.id}
                to={`/discounts/${discount.id}`}
                className="flex items-center bg-white/10 hover:bg-white/20 transition-all px-3 py-1.5 rounded-full backdrop-blur-sm shadow-sm"
              >
                <span className="text-sm font-medium">
                  {discount.title} — {formatDiscountValue(discount)}
                </span>

                {discount.partnerName && (
                  <span className="ml-2 text-xs text-primary-200">
                    від {discount.partnerName}
                  </span>
                )}

                {discount.validUntil && (
                  <span className="ml-3 text-xs text-primary-200 flex items-center">
                    <Clock size={12} className="mr-1" />
                    до {formatDate(discount.validUntil)}
                  </span>
                )}

                <ArrowRight size={14} className="ml-2 text-primary-200" />
              </Link>
            ))}
          </div>
        </div>
      </div>

      {/* CSS анімація */}
      <style jsx>{`
        @keyframes marquee {
          0% {
            transform: translateX(100%);
          }
          100% {
            transform: translateX(-100%);
          }
        }

        .animate-marquee {
          animation: marquee 25s linear infinite;
        }

        .animate-marquee:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
};

export default Marquee;
